import { render } from "./ReumHeader.vue?vue&type=template&id=01e52508&scoped=true"
import script from "./ReumHeader.vue?vue&type=script&lang=js"
export * from "./ReumHeader.vue?vue&type=script&lang=js"

import "./ReumHeader.vue?vue&type=style&index=0&id=01e52508&lang=scss&scoped=true"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e52508"]])

export default __exports__